import Vue from 'vue';

export const FlashBus = new Vue();

export default {
    install: function (Vue) {
        Vue.prototype.$flash = function(message = { message: '' }, delay = 0) {
            if (message.target) {
                FlashBus.$emit('flash-message-inline', message);
            } else {
                setTimeout( () => {
                    FlashBus.$emit('flash-message', message);
                }, delay) 
            }
        }
    },
}